import React, { ForwardRefExoticComponent, ReactNode } from 'react';
import Body from './Body/Body';
import { DialogElem } from './Dialog.styles';
import Footer from './Footer/Footer';
import Header from './Header/Header';

interface IDialogProps {
  children: ReactNode;
  className?: string;
}

interface IDialog extends ForwardRefExoticComponent<IDialogProps> {
  Body: typeof Body;
  Header: typeof Header;
  Footer: typeof Footer;
}

const Dialog = React.forwardRef<HTMLDialogElement, IDialogProps>(({ children, className }, ref) => {
  return <DialogElem {...{ className, ref }}>{children}</DialogElem>;
}) as IDialog;

Dialog.displayName = 'Dialog';
Dialog.Body = Body;
Dialog.Header = Header;
Dialog.Footer = Footer;

export default Dialog;
